var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomateHrWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 34.913 33.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18772",
    "data-name": "Group 18772",
    transform: "translate(-7650 9958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22786",
    "data-name": "Path 22786",
    d: "M1443.48,79.72v2.929a3.271,3.271,0,0,0,.968,2.33,3.332,3.332,0,0,0,2.341.965h2.944a3.3,3.3,0,0,0,3.308-3.295V79.72a3.3,3.3,0,0,0-3.308-3.295h-2.944a3.332,3.332,0,0,0-2.341.965A3.271,3.271,0,0,0,1443.48,79.72Zm2.205,0a1.089,1.089,0,0,1,.323-.776,1.112,1.112,0,0,1,.78-.322h2.944a1.112,1.112,0,0,1,.78.322,1.09,1.09,0,0,1,.323.776v2.929a1.09,1.09,0,0,1-.323.776,1.113,1.113,0,0,1-.78.322h-2.944a1.113,1.113,0,0,1-.78-.322,1.089,1.089,0,0,1-.323-.776Z",
    transform: "translate(6218.463 -10022.539)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22787",
    "data-name": "Path 22787",
    d: "M1432,68.295v2.929a3.3,3.3,0,0,0,3.308,3.295h2.944a3.331,3.331,0,0,0,2.341-.965,3.271,3.271,0,0,0,.967-2.33V68.295a3.271,3.271,0,0,0-.967-2.33,3.332,3.332,0,0,0-2.341-.965h-2.944A3.3,3.3,0,0,0,1432,68.295Zm2.205,0a1.089,1.089,0,0,1,.323-.776,1.112,1.112,0,0,1,.78-.322h2.944a1.112,1.112,0,0,1,.78.322,1.089,1.089,0,0,1,.323.776v2.929a1.089,1.089,0,0,1-.323.776,1.113,1.113,0,0,1-.78.322h-2.944a1.113,1.113,0,0,1-.78-.322,1.089,1.089,0,0,1-.323-.776Z",
    transform: "translate(6218 -10023)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22788",
    "data-name": "Path 22788",
    d: "M1454.96,91.145v2.929a3.3,3.3,0,0,0,3.308,3.295h2.934a3.317,3.317,0,0,0,3.319-3.295V91.145a3.317,3.317,0,0,0-3.319-3.295h-2.934a3.3,3.3,0,0,0-3.308,3.295Zm2.205,0a1.089,1.089,0,0,1,.323-.776,1.112,1.112,0,0,1,.78-.322h2.934a1.077,1.077,0,0,1,.78.322,1.144,1.144,0,0,1,.333.776v2.929a1.144,1.144,0,0,1-.333.776,1.077,1.077,0,0,1-.78.322h-2.934a1.113,1.113,0,0,1-.78-.322,1.089,1.089,0,0,1-.323-.776Z",
    transform: "translate(6218.926 -10022.079)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22789",
    "data-name": "Path 22789",
    d: "M1443.212,71.2h19.225a1.8,1.8,0,0,1,1.311.565,2.011,2.011,0,0,1,.541,1.365v5.4a2.011,2.011,0,0,1-.541,1.365,1.8,1.8,0,0,1-1.311.565h-4.432a1.151,1.151,0,0,0-.78.363,1.167,1.167,0,0,0,0,1.589,1.152,1.152,0,0,0,.78.363h4.432a4.03,4.03,0,0,0,1.571-.328,4.092,4.092,0,0,0,1.311-.915,4.4,4.4,0,0,0,1.186-3v-5.4a4.4,4.4,0,0,0-1.186-3,4.094,4.094,0,0,0-1.311-.915,4.03,4.03,0,0,0-1.571-.328h-19.225a1.159,1.159,0,0,0,0,2.314Z",
    transform: "translate(6218.408 -10022.843)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22790",
    "data-name": "Path 22790",
    d: "M1449.29,91.8h-13.243a1.839,1.839,0,0,1-1.841-1.83V84.84a1.839,1.839,0,0,1,1.841-1.83h8.094a1.111,1.111,0,0,0,.78-.322,1.1,1.1,0,0,0,0-1.553,1.111,1.111,0,0,0-.78-.322h-8.094a4.043,4.043,0,0,0-2.861,1.179A4.062,4.062,0,0,0,1432,84.84v5.125a4.062,4.062,0,0,0,1.186,2.848,4.043,4.043,0,0,0,2.861,1.179h13.243a1.068,1.068,0,0,0,.77-.322,1.072,1.072,0,0,0,0-1.553A1.068,1.068,0,0,0,1449.29,91.8Z",
    transform: "translate(6218 -10022.362)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22791",
    "data-name": "Path 22791",
    d: "M1459.777,83.308l-2.153-2.153L1459.777,79a1.111,1.111,0,0,0,.3-.768,1.14,1.14,0,0,0-.323-.757,1.116,1.116,0,0,0-1.54-.027l-2.934,2.929a1.021,1.021,0,0,0-.239.356,1.1,1.1,0,0,0,0,.84,1.022,1.022,0,0,0,.239.356l2.934,2.929a1.116,1.116,0,0,0,1.54-.027,1.14,1.14,0,0,0,.323-.757A1.111,1.111,0,0,0,1459.777,83.308Z",
    transform: "translate(6218.926 -10022.51)",
    fill: "#96006b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22792",
    "data-name": "Path 22792",
    d: "M1448.992,96.285l2.944-2.929a1.188,1.188,0,0,0,.239-.356,1.1,1.1,0,0,0,0-.84,1.187,1.187,0,0,0-.239-.356l-2.944-2.929a1.109,1.109,0,0,0-.77-.295,1.085,1.085,0,0,0-.76.321,1.1,1.1,0,0,0-.031,1.525l2.164,2.153-2.164,2.153a1.1,1.1,0,0,0,.031,1.525,1.085,1.085,0,0,0,.76.322A1.109,1.109,0,0,0,1448.992,96.285Z",
    transform: "translate(6218.61 -10022.05)",
    fill: "#96006b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomateHrWorkflow);
export default __webpack_public_path__ + "static/media/automateHRWorkflow.13bb34c132284a465012c5160587de43.svg";
export { ForwardRef as ReactComponent };